module.exports = __webpack_public_path__ + "static/media/15.dae98747.JPG";